import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams, Link } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import Iframe from "react-iframe";
import uploadIcon from "../resources/images/upload-icon.png";
import MdlSelectSession from "../dialog/MdlSelectSession";
import myToast from "../Utils/MyToast";

const UdiseReport = () => {
  const slt_board = useRef(null);
  const slt_medium = useRef(null);

  const token = localStorage.getItem("token");
  const [loggedIn, setLoggedIn] = useState(token != null);
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [mClassData, setClassData] = useState([]);
  const [mClassBoard, setClassBoard] = useState([]);
  const [mClassMedium, setClassMedium] = useState([]);

  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [SESSION_NAME, setSESSION_NAME] = useState("");
  const [SESSION_STATUS, setSESSION_STATUS] = useState("");

  const [mPrintableSamples, setPrintableSamples] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileDirectory, setFileDirectory] = useState("");
  const [selectedSampleId, setSelectedSampleId] = useState("");

  const { document_type } = useParams();
  const [height, setHeight] = useState("300px");
  const iframeRef = useRef(null);

  useEffect(() => {
    const mSession = SessionManager.getCurrentSession();
    setSESSION_ID(mSession[0].session_id);
    setSESSION_NAME(mSession[0].session_name);
    setSESSION_STATUS(mSession[0].status);
    getBoardAndMedium(mSession[0].session_id);

    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    const board_id =
      slt_board.current?.selectedOptions[0]?.getAttribute("board_id");
    const medium_id =
      slt_medium.current?.selectedOptions[0]?.getAttribute("medium_id");

    if (!board_id || !medium_id) {
      return;
    }
    //alert(board_id + medium_id);
    updateFileUrl(board_id, medium_id, SESSION_ID);
  }, [selectedSampleId]);

  const fetchPrintableSamples = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: document_type,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          const firstSample = response.data[0];
          setPrintableSamples(response.data);
          setFileName(firstSample.file_name);
          setFileDirectory(firstSample.file_directory);
          setSelectedSampleId(firstSample.sample_id);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching samples", error);
      });
  };
  const getBoardAndMedium = (session_id) => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getBoardAndMedium.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: { school_code: SCHOOL_CODE, session_id },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);

        if (response.api_status === "OK") {
          setClassBoard(response.data.board);
          setClassMedium(response.data.medium);
          fetchPrintableSamples();
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>", error);
      });
  };

  const ChangeSession = () => setIsOpenSessionDialog(true);
  const HandleCloseSessionDialog = () => setIsOpenSessionDialog(false);

  const HandleSelectedSession = (session_id, session_name, session_status) => {
    setSESSION_ID(session_id);
    setSESSION_NAME(session_name);
    setSESSION_STATUS(session_status);
    setIsOpenSessionDialog(false);
  };

  const onBoardChange = () => {
    const board_id =
      slt_board.current?.selectedOptions[0]?.getAttribute("board_id");
    const medium_id =
      slt_medium.current?.selectedOptions[0]?.getAttribute("medium_id");

    if (!board_id || !medium_id) {
      return;
    }
    updateFileUrl(board_id, medium_id, SESSION_ID);
  };

  const onMediumChange = () => {
    const board_id =
      slt_board.current?.selectedOptions[0]?.getAttribute("board_id");
    const medium_id =
      slt_medium.current?.selectedOptions[0]?.getAttribute("medium_id");

    if (!board_id || !medium_id) {
      return;
    }
    updateFileUrl(board_id, medium_id, SESSION_ID);
  };

  const updateFileUrl = (board_id, medium_id, session_id) => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();

    const url =
      process.env.REACT_APP_SERVER_NAME +
      fileDirectory +
      fileName +
      "?&board_id=" +
      board_id +
      "&medium_id=" +
      medium_id +
      "&session_id=" +
      session_id +
      "&school_code=" +
      SCHOOL_CODE;

    console.log("URL>>>", url);

    setFileUrl(url);
    setShowPreview(true);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <div className="content">
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <a href="#">Udise Report</a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="animated fadeInUpn bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "10px" }}
      >
        {/* Session Header */}
        <div className="row">
          <div className="col-sm-12 col-md-12">
            <Link to="#" onClick={ChangeSession}>
              <p
                className="bg_card_blue"
                style={{
                  padding: "1px 5px 1px 5px",
                  fontSize: "18px",
                  textAlign: "center",
                  color: COLORS.white,
                }}
              >
                Session: {SESSION_NAME} ({SESSION_STATUS})
                <span style={{ float: "right" }}>
                  <img
                    src={uploadIcon}
                    alt="upload image"
                    className="bg_card_blue"
                    style={{ height: "25px", width: "25px" }}
                  />
                </span>
              </p>
            </Link>
          </div>
        </div>

        {/* Select Board & Medium */}
        <div className="row m-0">
          <div className="col-sm-6 col-md-6">
            <select
              className="bg_card_blue width_match_parent h_35"
              onChange={onBoardChange}
              ref={slt_board}
            >
              {mClassBoard &&
                mClassBoard.map((item, index) => (
                  <option key={index} board_id={item.board_id}>
                    {item.board_name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-sm-6 col-md-6">
            <select
              className="bg_card_blue width_match_parent h_35"
              onChange={onMediumChange}
              ref={slt_medium}
            >
              {mClassMedium &&
                mClassMedium.map((item, index) => (
                  <option key={index} medium_id={item.medium_id}>
                    {item.medium_name}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className="row" style={{ margin: "0px 10px 0px 10px" }}>
          <h5 className="">Udise Report</h5>
        </div>

        <div className="row" style={{ margin: "0px 10px 0px 10px" }}>
          {showPreview && (
            <div>
              <MyLoader />
            </div>
          )}

          <Iframe
            ref={iframeRef}
            src={fileUrl}
            width="100%"
            height={height}
            style={{ border: "none", overflow: "hidden" }}
            id="iFrame1"
            scrolling="no"
            onLoad={() => setShowPreview(false)}
          />
        </div>
        {isOpenSessionDialog && (
          <MdlSelectSession
            action={HandleCloseSessionDialog}
            action2={HandleSelectedSession}
          />
        )}
      </div>
    </div>
  );
};

export default UdiseReport;
